module.exports = __webpack_public_path__ + "static/media/huoshaoshan_web.9f9c1a70.png";